'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { CONSENT_CHANGED_EVENT } from '@/lib/cookie-consent';
import { captureInviteFromSearch, inviteConsentChanged } from '@/lib/invite-link-client';

/**
 * Picks up a referral link's ?invite= code on every page (src/lib/invite-link.ts)
 * and keeps the device copy in step with the visitor's analytics choice.
 *
 * Runs on every change of path OR query, so a client-side move from /sell to
 * /sell?invite=x is caught too. useSearchParams needs no Suspense boundary
 * here: it asks for one only while a page is prerendered, and none is (the
 * root layout reads headers(); see the note in src/app/providers.tsx, which
 * must not gain a boundary). Renders nothing.
 */
export function InviteLinkCapture() {
  const pathname = usePathname();
  const search = useSearchParams()?.toString() ?? '';

  useEffect(() => {
    captureInviteFromSearch(search);
  }, [pathname, search]);

  useEffect(() => {
    window.addEventListener(CONSENT_CHANGED_EVENT, inviteConsentChanged);
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, inviteConsentChanged);
  }, []);

  return null;
}
